import { AxiosResponse } from 'axios';
import { getTeams } from '../api/teamsApi';
import { getTeamsError, getTeamsRequest, getTeamsSuccess } from '.';
import { all, call, put, takeLatest } from 'redux-saga/effects';

export function* getTeamsSaga() {
    try {
        const response: AxiosResponse = yield call(getTeams);
        yield put(getTeamsSuccess(response));
    } catch (error) {
        yield put(getTeamsError(error));
    }
}

export default function* teamsSagaWatcher() {
    yield all([takeLatest(getTeamsRequest, getTeamsSaga)]);
}
